export default __webpack_public_path__ + "static/media/howItWorksHire4.d85ec996.png";